import * as THREE from "three";
import getPosInfo from "./getPosInfo";
import addAdditionalFacingRow from "./additionalFacingRow";
import * as SkeletonUtils from 'three/examples/jsm/utils/SkeletonUtils'

const addFacingSide = (model, elementBbox, heightOnEarth) => {

    let frontGroup = new THREE.Group();
    let backGroup = new THREE.Group();
    let rightGroup = new THREE.Group();
    let leftGroup = new THREE.Group();
    let finalGroup = new THREE.Group();
    const dopusk = 0.001;
    const sinkH = 0.00001;

    model.rotation.x = Math.PI / 2;

    let bboxModel = getPosInfo(model);

    const xSize = elementBbox.xSize;
    const ySize = heightOnEarth;
    const zSize = elementBbox.zSize;
    //узнаем количество элементов в задней и передней сторонах
    const countInWidth = xSize / bboxModel.xSize;
    const countInWidthInt = Math.trunc(countInWidth);
    const countInWidthFract = countInWidth - countInWidthInt;

    const countInHeight = ySize / bboxModel.ySize;
    const countInHeightInt = Math.trunc(countInHeight);
    const countInHeightFract = countInHeight - countInHeightInt;

    const countInLength = zSize / bboxModel.xSize;
    const countInLengthInt = Math.trunc(countInLength);
    const countInLengthFract = countInLength - countInLengthInt;

    const epsY = 0.00001;
    model.position.set(
        elementBbox.bbox.min.x + bboxModel.xSize / 2,
        heightOnEarth - epsY - bboxModel.bbox.max.y,
        elementBbox.bbox.max.z + bboxModel.zSize / 2
    );

    //Создаем переднюю сторону
    frontGroup.add(model);
    for (let index = 2; index <= countInWidthInt; index++) {
        const newModel = model.clone();
        newModel.position.x += (index - 1) * bboxModel.xSize;
        frontGroup.add(newModel);
    }
    if (parseFloat(countInWidthFract) > dopusk) {
        const newModel = model.clone();
        newModel.position.x += countInWidthInt * bboxModel.xSize;
        newModel.position.x -= bboxModel.xSize - bboxModel.xSize * countInWidthFract;
        newModel.position.z -= sinkH;
        frontGroup.add(newModel);
    }

    //дополнительные ряды
    if (parseFloat(countInHeight) > 1) {
        frontGroup = addAdditionalFacingRow(frontGroup, bboxModel, countInHeightInt, countInHeightFract, dopusk, sinkH, 'front');
    } else {
        //подрезаем единственный ряд
        const bboxLine = getPosInfo(frontGroup);
        const subY = bboxModel.ySize - bboxModel.ySize * countInHeight;
        const subMesh = new THREE.Mesh(
            new THREE.BoxGeometry(bboxLine.xSize, subY, bboxLine.zSize),
            new THREE.MeshBasicMaterial()
        );
        subMesh.position.set(frontGroup.position.x, bboxLine.bbox.min.y + subY / 2, bboxLine.bbox.max.z - bboxLine.zSize / 2);

        frontGroup.add(subMesh);

    }

    //Создаем заднюю группу
    // const bModel = model.clone();
    const bModel = SkeletonUtils.clone(model);
    bModel.position.copy(model.position);
    bModel.rotation.z = Math.PI;
    bModel.position.z = elementBbox.bbox.min.z - bboxModel.zSize / 2;

    backGroup.add(bModel);
    for (let index = 2; index <= countInWidthInt; index++) {
        const newModel = bModel.clone();
        newModel.position.x += (index - 1) * bboxModel.xSize;
        backGroup.add(newModel);
    }
    if (parseFloat(countInWidthFract) > dopusk) {
        const newModel = bModel.clone();
        newModel.position.x += countInWidthInt * bboxModel.xSize;
        newModel.position.x -= bboxModel.xSize - bboxModel.xSize * countInWidthFract;
        newModel.position.z += sinkH;
        backGroup.add(newModel);
    }
    //дополнительные ряды
    if (parseFloat(countInHeight) > 1) {
        backGroup = addAdditionalFacingRow(backGroup, bboxModel, countInHeightInt, countInHeightFract, dopusk, sinkH, 'back');
    } else {
        //сжать единственный ряд
    }

    //создаем левую группу
    const lModel = model.clone();
    lModel.rotation.z = Math.PI / 2;
    bboxModel = getPosInfo(lModel);
    lModel.position.x = elementBbox.bbox.min.x - bboxModel.xSize / 2
    lModel.position.z = elementBbox.bbox.min.z + bboxModel.zSize / 2

    leftGroup.add(lModel);

    for (let index = 2; index <= countInLengthInt; index++) {
        const newModel = lModel.clone();
        newModel.position.z += (index - 1) * bboxModel.zSize;
        leftGroup.add(newModel);
    }
    if (parseFloat(countInLengthFract) > dopusk) {
        const newModel = lModel.clone();
        newModel.position.z += countInLengthInt * bboxModel.zSize;
        newModel.position.z -= bboxModel.zSize - bboxModel.zSize * countInLengthFract;
        newModel.position.x += sinkH;
        leftGroup.add(newModel);
    }
    //дополнительные ряды
    if (parseFloat(countInHeight) > 1) {
        leftGroup = addAdditionalFacingRow(leftGroup, bboxModel, countInHeightInt, countInHeightFract, dopusk, sinkH, 'left');
    } else {
        //сжать единственный ряд
    }


    //Создаем правую группу
    const rModel = model.clone();
    rModel.rotation.z = -Math.PI / 2;
    bboxModel = getPosInfo(rModel);
    rModel.position.x = elementBbox.bbox.max.x + bboxModel.xSize / 2
    rModel.position.z = elementBbox.bbox.min.z + bboxModel.zSize / 2

    rightGroup.add(rModel);

    for (let index = 2; index <= countInLengthInt; index++) {
        const newModel = rModel.clone();
        newModel.position.z += (index - 1) * bboxModel.zSize;
        rightGroup.add(newModel);
    }
    if (parseFloat(countInLengthFract) > dopusk) {
        const newModel = rModel.clone();
        newModel.position.z += countInLengthInt * bboxModel.zSize;
        newModel.position.z -= bboxModel.zSize - bboxModel.zSize * countInLengthFract;
        newModel.position.x += sinkH;
        rightGroup.add(newModel);
    }
    //дополнительные ряды
    if (parseFloat(countInHeight) > 1) {
        rightGroup = addAdditionalFacingRow(rightGroup, bboxModel, countInHeightInt, countInHeightFract, dopusk, sinkH, 'right');
    } else {
        //сжать единственный ряд
    }

    finalGroup.add(frontGroup);
    finalGroup.add(backGroup);
    finalGroup.add(rightGroup);
    finalGroup.add(leftGroup);

    return finalGroup;


}
export default addFacingSide;
